module.exports = __webpack_public_path__ + "img/Interview_rej.470924c4.svg";